// Sizing shortcuts

@mixin size($width, $height: $width) {
  width: $width;
  height: $height;
}
